import React, { useEffect, useRef } from "react";
import styles from "../components/comp_css/chapter_58.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter70.json";
import Head from "next/head";

export default function Chapter_70() {

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;

  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])
  return (
    <>
    <Head>
        <title>Central Doctrine | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Central Doctrine | School of Our Divine Infinite Being"
        ></meta>
        <meta
          property="og:title"
          content="The Gospel of Thomas: Bridging Ancient Wisdom Traditions"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          property="og:description"
          content="The Gospel of Thomas arose in Alexandria’s age of cultural fusion, blending Platonism, Hermeticism, and early Christianity. Rooted in shared divine archetypes and mystery school wisdom, it reveals hidden truths for spiritual awakening. This text bridges ancient traditions, reflecting a universal quest for knowledge, unity, and the eternal connection between humanity and the divine."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=70"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=70"
        ></meta>
        <meta
          name="twitter:title"
          content="The Gospel of Thomas: Bridging Ancient Wisdom Traditions"
        ></meta>
        <meta
          name="twitter:description"
          content="Emerging from Alexandrian syncretism, the Gospel of Thomas unites Platonism, Hermetic thought, and early Christian teachings. Its sayings echo the mystery schools’ pursuit of hidden knowledge and spiritual awakening. Born from a melting pot of cultures, it invites seekers to explore timeless truths where philosophy, scripture, and divine wisdom converge in a single spiritual vision."
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=70" />
      </Head>
      <Common_html BlockData={BlockData} />
    </>
  );
}
